var _rect, _path, _rect2, _rect3, _rect4, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 638,
    viewBox: "0 0 1440 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#063065"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_993_2140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 1443,
    height: 638
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1444 0H1V638H1444V0Z",
    fill: "#063065"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_993_2140)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -102,
    y: 939,
    width: 845.7,
    height: 845.7,
    rx: 100,
    transform: "rotate(-135 -102 939)",
    fill: "url(#paint0_linear_993_2140)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_993_2140",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -659,
    y: -216,
    width: 1114,
    height: 1114
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -102,
    y: 939,
    width: 845.7,
    height: 845.7,
    rx: 100,
    transform: "rotate(-135 -102 939)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_993_2140)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.215346
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 532.572,
    y: 869.229,
    width: 704.75,
    height: 704.75,
    rx: 100,
    transform: "rotate(-135 532.572 869.229)",
    fill: "url(#paint1_linear_993_2140)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.158873
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -101.703,
    y: 1006.1,
    width: 704.75,
    height: 704.75,
    rx: 100,
    transform: "rotate(-135 -101.703 1006.1)",
    fill: "url(#paint2_linear_993_2140)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_993_2140",
    x1: 320.85,
    y1: 939,
    x2: 320.85,
    y2: 1784.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_993_2140",
    x1: 884.947,
    y1: 869.229,
    x2: 884.947,
    y2: 1573.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_993_2140",
    x1: 250.672,
    y1: 1006.1,
    x2: 250.672,
    y2: 1710.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_993_2140",
    x1: 138.193,
    y1: 402.605,
    x2: 138.193,
    y2: 420.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#063065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_993_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1171 391)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_993_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(127 398.309)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_993_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(227 398.309)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_993_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(277 398.309)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackIcon);
export default __webpack_public_path__ + "static/media/FooterBackIcon.ea6ee85163f2269621f6e4824d1657a7.svg";
export { ForwardRef as ReactComponent };